import _tokens from './tokens.js'
import { extractUnits } from './utils.js'

import { UnitType } from '@exodus/currency'

const name = 'bnbmainnet'
const displayName = 'BNB'
const ticker = 'BNB'
const displayTicker = 'BNB'
const displayNetworkTicker = displayTicker
const displayNetworkName = 'BNB Beacon Chain'
const baseAssetName = name
const primaryColor = '#FFB700'
const gradientColors = ['#FFB700', '#D8AC29']
const gradientCoords = { x1: '0%', y1: '0%', x2: '102%', y2: '101%' }
const chainBadgeColors = gradientColors

const units = {
  zhao: 0,
  BNB: 8,
}
const currency = UnitType.create(units)

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.binance.org/address/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://explorer.binance.org/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    "BNB is the native token of BNB Beacon Chain and the key base asset on the Binance decentralized exchange (DEX). It is used to pay the transaction fees of assets that live on BNB Beacon Chain. Holding BNB gives you the right to make your voice heard and is necessary for participation in BNB Beacon Chain's decentralized on-chain governance.",
  reddit: 'https://www.reddit.com/r/binance/',
  twitter: 'https://www.twitter.com/binance',
  website: 'https://www.binance.com/',
  telegram: 'https://t.me/BinanceExchange',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export const tokens = _tokens.map((token) => {
  const units = extractUnits(token)
  return {
    ...token,
    // name,
    // displayName,
    // decimals,
    // ticker,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    assetId: token.assetId,
    assetType: 'BINANCE_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    currency: UnitType.create(units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    info: token.info || {},
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    tokenType: 'BEP2',
    toString: () => token.name,
    units,
  }
})

export default [asset, ...tokens]
